import * as service from './service'
export default {
  namespace: 'shansongStudyStudySearch',
  state: {
    searchData: []
  },
  effects: {
    * getTrainSearchList ({ payload }, { call, put }) {
      const res = yield call(service.getTrainSearchList, payload)
      yield put({
        type: 'save',
        payload: {
          searchData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
